
import Icon from "@ant-design/icons";
import { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const MemberSVG = () => (<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M8.33333 12C11.3666 12 13.8333 9.53325 13.8333 6.5C13.8333 3.46675 11.3666 1 8.33333 1C5.30008 1 2.83333 3.46675 2.83333 6.5C2.83333 9.53325 5.30008 12 8.33333 12ZM8.33333 3.75C9.8495 3.75 11.0833 4.98383 11.0833 6.5C11.0833 8.01617 9.8495 9.25 8.33333 9.25C6.81717 9.25 5.58333 8.01617 5.58333 6.5C5.58333 4.98383 6.81717 3.75 8.33333 3.75ZM15.6667 21.1667V21.625C15.6667 22.3849 15.0507 23 14.2917 23C13.5327 23 12.9167 22.3849 12.9167 21.625V21.1667C12.9167 18.6394 10.8606 16.5833 8.33333 16.5833C5.80608 16.5833 3.75 18.6394 3.75 21.1667V21.625C3.75 22.3849 3.134 23 2.375 23C1.616 23 1 22.3849 1 21.625V21.1667C1 17.1233 4.28992 13.8333 8.33333 13.8333C12.3767 13.8333 15.6667 17.1233 15.6667 21.1667Z" fill="current" stroke="current"/>
</svg>
);

export const MemberIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={MemberSVG} {...props} />
);

